import AncestrySource from './ancestry';
import FamilySearchSource from './familysearch';
import BlankSource from './blank';
import PhotoSource from './photo';
import { CalendarSource, CalendarSourceAncestry, CalendarSourceFamilySearch, CalendarSourceMyCanvas } from './calendar';
import TestSource from './test';

const getSourceComponent = (type = 'photos') => {
  switch (type) {
    case 'ancestry':
      return AncestrySource;

    case 'familysearch':
      return FamilySearchSource;

    case 'calendar':
      return CalendarSource;

    case 'calendar-ancestry':
      return CalendarSourceAncestry;

    case 'calendar-familysearch':
      return CalendarSourceFamilySearch;

    case 'calendar-mycanvas':
      return CalendarSourceMyCanvas;

    case 'test':
      return TestSource;

    case 'blank':
      return BlankSource;

    default:
      return PhotoSource;
  }
};

export default getSourceComponent;
